module.exports = __webpack_public_path__ + "static/img/6.46fa841.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/6.png
// module id = 0uix
// module chunks = 0